import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-hyginestaft-image-dialog',
  templateUrl: './hyginestaft-image-dialog.component.html',
  styleUrls: ['./hyginestaft-image-dialog.component.scss']
})
export class HyginestaftImageDialogComponent {
  picture:any;
  staffList: any[] = [];
  campusName = '';
  buildingName = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private dialogRef: MatDialogRef<HyginestaftImageDialogComponent>
  ) {
    this.picture = data.picture;
    const p = data.picture as any;
    this.staffList = Array.isArray(p?.staffDetails) ? p.staffDetails : [];
    this.campusName = p?.campusName ?? '';
    this.buildingName = p?.buildingName ?? '';
  }

  close(): void {
    this.dialogRef.close();
  }

  formatHygieneTime(dateStr: string): string {
     if (!dateStr) return '';

  const [datePart, timePart] = dateStr.split(' ');
  if (!datePart || !timePart) return dateStr;

  const [day, month, year] = datePart.split('-');
  const [h, m, s] = timePart.split(':');

  let hours = parseInt(h, 10);
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  return `${day}-${month}-${year} ${String(hours).padStart(2,'0')}:${m}:${s} ${ampm}`;
}
}
